import EXIF from "exif-js";

const THREE = require('three');
import './orbitcontrols';

export class View360 {

    constructor(selector, canvasWidth = 1280, canvasHeight = 800) {
        this.renderer = null;
        this.camera = null;
        this.scene = null;
        this.sphere = null;
        this.controls = null;
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
        this.selector = selector;
        this.SPHERE_RADIUS = 900;
        this.TEXTURE_LOADER = new THREE.TextureLoader();
        this.isInit = false;
    }

    // View.setSize = setSize;
    // View.getCanvas = getCanvas;

    // Object.preventExtensions(View);
    // Object.seal(View);
    // Object.freeze(View);

    getCanvas() {
        return this.renderer.domElement;
    }

    setSize(w, h) {
        this.canvasWidth = w;
        this.canvasHeight = h;

        if (this.renderer) {
            this.camera.aspect = this.canvasWidth / this.canvasHeight;
            this.camera.updateProjectionMatrix();

            this.renderer.setSize(this.canvasWidth, this.canvasHeight);
        }
    }

    init(id) {
        if (!this.isInit) {
            this.isInit = true;
        }
        this.container = document.querySelector(this.selector);
        this.imageUrl = this.container.dataset.image;

        this.renderer = new THREE.WebGLRenderer();
        this.renderer.domElement.setAttribute('id', id);
        this.renderer.setPixelRatio(1.5);
        this.renderer.setSize(this.canvasWidth, this.canvasHeight);
        this.renderer.setClearColor(0xEFEFEF);
        this.renderer.domElement.style.border = 'solid 1px #CCC';

        this.camera = new THREE.PerspectiveCamera(55, this.canvasWidth / this.canvasHeight, 1, 1500);
        this.camera.position.set(0, -100, 50);

        this.scene = new THREE.Scene();
        this.scene.add(this.camera);
        this.scene.add(new THREE.AmbientLight(0x888888));

        this.prepare().then(({ map, picture }) => {
            map.minFilter = THREE.LinearFilter;
            this.sphere = new THREE.Mesh
            (
                new THREE.SphereGeometry(this.SPHERE_RADIUS, 60, 40),
                new THREE.MeshBasicMaterial({map: map, side: THREE.DoubleSide})
            );

            this.scene.add(this.sphere);

            const isNew360 = /RICOH THETA SC2/i.test(EXIF.getTag(picture, 'Model'))
            this.sphere.rotation.x = isNew360 ? Math.PI / 180 : Math.PI / 180 * 90;
            this.sphere.scale.x = -1;

            this.controls = new THREE.OrbitControls(this.camera, this.renderer.domElement);
            this.controls.autoRotate = false;
            this.controls.enablePan = false;
            this.controls.enableKeys = false;
            this.controls.zoomSpeed = 5;
            this.controls.minAzimuthAngle = this.controls.maxAzimuthAngle = isNew360 ? Math.PI / 180 * 90 : Math.PI / 180 * -90;
            this.controls.maxDistance = this.controls.minDistance = 400;
            this.controls.minPolarAngle = Math.PI / 180 * 90;
            this.controls.maxPolarAngle = Math.PI / 180 * 90;
            this.controls.update();

            this.controls.minAzimuthAngle = -Infinity;
            this.controls.maxAzimuthAngle = Infinity;
            this.controls.minPolarAngle = 0;
            this.controls.maxPolarAngle = Math.PI / 180 * 180;
            this.controls.maxDistance = 600;
            this.controls.minDistance = 5;

            this.render();
        });

    }

    prepare() {
        return new Promise(resolve => {
            this.TEXTURE_LOADER.load(this.imageUrl, (map) => {
                EXIF.getData(map.image, function() {
                    resolve({ map, picture: this});
                });
            });
        })
    }

    render() {
        this.renderer.render(this.scene, this.camera);
        requestAnimationFrame(() => this.render());
        this.container.insertAdjacentElement('afterbegin', this.getCanvas());
    }

}
